import React, { useState } from "react";
import Modal from "react-modal";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { FiX } from "react-icons/fi";
import "./CustomModalPremium.css";

Modal.setAppElement("#root");

const CustomModal = ({ isOpen, onRequestClose, modalData }) => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone: "",
    description: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const access_key = "41c2c80f-1527-4cbd-8101-2f4c5dd07683";

    if (formData.username && formData.email && formData.phone) {
      const formDataForAPI = {
        subject: `New Order: ${modalData?.title} Package by ${formData?.username} - Oglitz Software`,
        name: formData.username,
        email: formData.email,
        phone: formData.phone,
        message: formData.description,
        access_key,
        packageId: modalData?.id,
        packageName: modalData?.title,
        packagePrice: modalData?.price,
        packageDuration: modalData?.duration,
        packageDescription: modalData?.description,
        packageBenefits: modalData?.benefits,
      };

      try {
        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formDataForAPI),
        });

        if (response.ok) {
          const orderRef = collection(db, "designOrders");
          await addDoc(orderRef, formDataForAPI);

          toast.success("Thank you! Our team will contact you shortly.");
          setFormData({
            username: "",
            email: "",
            phone: "",
            description: "",
          });
          onRequestClose();
        } else {
          toast.error("Submission failed. Please try again.");
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please fill all required fields.");
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      ariaHideApp={false}
      style={{
        overlay: {
          backgroundColor: "rgba(11, 47, 44, 0.65)",
          backdropFilter: "blur(6px)",
          zIndex: 999999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        content: {
          position: "relative",
          inset: "auto",
          padding: "24px",
          borderRadius: "14px",
          border: "none",
          maxWidth: "520px",
          width: "92%",
          background: "#ffffff",
          boxShadow: "0 40px 120px rgba(0,0,0,0.25)",
        },
      }}
    >
      {/* HEADER */}
      <div className="oglitz-modal-header">
        <div>
          <h3>Request Design Package</h3>
          <p>{modalData?.title || "Social Media Design Package"}</p>
        </div>
        <button className="oglitz-modal-close" onClick={onRequestClose}>
          <FiX />
        </button>
      </div>

      {/* BODY */}
      <div className="oglitz-modal-body">
        <Form>
          <Form.Group>
            <Form.Label>Your Name *</Form.Label>
            <Form.Control
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Enter your full name"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Email *</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="you@example.com"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Phone Number *</Form.Label>
            <Form.Control
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+91 XXXXX XXXXX"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Project Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Tell us about your requirements..."
            />
          </Form.Group>
        </Form>
      </div>

      {/* FOOTER */}
      <div className="oglitz-modal-footer">
        <button
          className="oglitz-modal-submit"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit Request"}
        </button>

        <button
          className="oglitz-modal-cancel"
          onClick={onRequestClose}
          disabled={loading}
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default CustomModal;
